import { METHODS } from "@app/kit";
import { MerchantEmployeeActivityScansDTO, type MerchantEmployeeScanCustomerDTO } from "@app/dto";

import { api } from "../api";
import { MOCK, mock } from "../mock";

// Сканы текущей консультации: продавец сканирует тегом «Сканер» на главной приложения карту клиента и
// бирки изделий, 1С ведёт журнал, сервер проксирует «что отсканировано в текущей консультации».
// Формат один у 1С, сервера и приложения — DTO из @app/dto.

export type ActivityScans = MerchantEmployeeActivityScansDTO;
export type ScanCustomer = MerchantEmployeeScanCustomerDTO;
// Ровно одно из двух — сервер отказывает и пустому, и двойному.
export type ScanInput = { phone: string } | { barcode: string };

const url = (path: string) => `/v1/merchant-employee/${path}`;

const scansRequest = api.createRequest({
  url: url("shift/state/scans"),
  method: METHODS.GET,
  entity: MerchantEmployeeActivityScansDTO,
});
export const getScans = () => (MOCK ? mock.getScans() : scansRequest());

const scanRequest = api.createRequest({
  url: url("shift/state/scan"),
  method: METHODS.POST,
  entity: MerchantEmployeeActivityScansDTO,
});
// Телефон из шторки (или штрихкод, введённый руками) — тот же скан, что с камеры; в ответ — сканы консультации.
export const sendScan = (body: ScanInput) => (MOCK ? mock.sendScan(body) : scanRequest({ body }));
